var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandscaping(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M16.5,25.1H18v1.8v3.6h7.4L22.7,25c-0.1-0.3-0.1-0.6,0.1-0.8c0.1-0.2,0.4-0.3,0.6-0.3H25l-4.1-6.2 c-0.1-0.3-0.2-0.6,0-0.8c0.1-0.2,0.3-0.4,0.6-0.4h1l-5.3-7l-5.2,7h1c0.3,0,0.5,0.1,0.6,0.4c0.2,0.2,0.1,0.5,0,0.8l-4.1,6.2h1.6 c0.2,0,0.5,0.1,0.6,0.3c0.2,0.2,0.2,0.5,0.1,0.8l-2.7,5.5h7.4V25.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCC00",
    cx: 32.6,
    cy: 12,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M34.6,33c-0.3-0.3-0.8-0.3-1.2-0.1l-1.8,1.2l-2-2c-0.4-0.3-0.9-0.3-1.3,0L23.6,36H18v-4h8.6 c0.3,0,0.5-0.2,0.7-0.4c0.1-0.2,0.1-0.5,0-0.7l-2.7-5.5h1.8c0.3,0,0.5-0.2,0.6-0.4c0.2-0.2,0.2-0.6,0-0.8L22.9,18h1 c0.3,0,0.6-0.2,0.7-0.4c0.1-0.3,0.1-0.6-0.1-0.8l-6.7-9c-0.1-0.2-0.4-0.3-0.6-0.3l-0.6,0.3l-6.7,9c-0.1,0.3-0.1,0.5,0,0.8 c0.1,0.2,0.4,0.4,0.7,0.4h1l-4.1,6.2c-0.1,0.3-0.2,0.6,0,0.8c0.1,0.2,0.3,0.4,0.6,0.4h1.8l-2.7,5.5c-0.1,0.2-0.1,0.5,0,0.7 C7.4,31.8,7.6,32,7.9,32h8.6v4H6v1.5h33V36h-0.6L34.6,33z M9.1,30.5l2.7-5.5c0.1-0.3,0.1-0.6-0.1-0.8c-0.1-0.2-0.4-0.3-0.6-0.3H9.5 l4.1-6.2c0.1-0.3,0.2-0.6,0-0.8c-0.1-0.3-0.3-0.4-0.6-0.4h-1l5.2-7l5.3,7h-1c-0.3,0-0.5,0.2-0.6,0.4c-0.2,0.2-0.1,0.5,0,0.8 l4.1,6.2h-1.6c-0.2,0-0.5,0.1-0.6,0.3c-0.2,0.2-0.2,0.5-0.1,0.8l2.7,5.5H18v-3.6v-1.8h-1.5v5.4H9.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscaping);
export default __webpack_public_path__ + "static/media/landscaping.7faa5b1ceb7815407cb3171f43c8117c.svg";
export { ForwardRef as ReactComponent };